<script>
	import Row from './Row.svelte';
	import WordCloud from './WordCloud.svelte';
	import {link} from 'svelte-spa-router';	
	import Gallery from './Gallery.svelte';
	let cloud = false;

	let activeImg;

</script>
<!-- svelte-ignore a11y-missing-attribute -->
<main>
	<Row klass="all-center bg-dots-xs">
		<div class="bg-dots-big"><h1 class="caps w-800 text-right primary">Diabetes<br>during<br>COVID-19</h1></div>
		<div class="bg-dots-big"><h1 class="caps w-100 text-left">Capturing<br>experiences<br>of a pandemic</h1></div>
	</Row>
	<Row klass="all-center row-big">
		<div class="all-center full-width">
				<h2 class="full-width"><span class="w-400 primary">We want to give people with diabetes 
					a space to share and reflect on their experiences 
					of the pandemic and lockdown: </span>
				<span class="w-200">connecting them with healthcare researchers, providers, and artists.</span></h2>
			</div>
	</Row>
	<Row klass="all-center">
		<h1 class="caps w-800 full-width all-center"><a use:link={'/exhibition'}>Explore Exhibition</a></h1>
	</Row>
	<Row klass="row-big">
		<div class="bg-dots-xs full-width all-center">
			<h2 class="w-200 primary full-width">
				We invited people with Diabetes to submit art or written work of any form, reflecting on their unique experience during the Covid-19 pandemic. The goal: To inspire a collaborative artwork which now can be explored here digitally, and physically at a range of locations.
			</h2>
		</div>
	</Row>
	<Row>
		<div class="text-center full-with all-center">
			<h2 class="w-800 primary caps">Artworks</h2>
			<p style="padding-top: 0;">by <a href="https://www.yejeong.com/" target="_blank" style="outline: none; padding: 0; margin: 0; line-height: 1; display: inline; text-decoration: underline;">Yejeong Mutter </a></p>
			<p style="padding-top: 0;">The exhibition will be displayed at a range of locations. 
				<!-- <br><a style="outline: none; padding: 0; margin: 0; line-height: 1; display: inline; text-decoration: underline;" href="https://airtable.com/shr5ZHYgHkpFsSM2L" target="_blank">Get notified by Email about dates and places</a>. -->
			</p>
		</div>
		<div>
			<div style="margin: 0 auto 40px auto; padding: 20px; display: grid; grid-template-columns: repeat(auto-fit,minmax(300px,1fr)); grid-gap: var(--gap-s);">
				<div>
					<img style="max-width: 100%;" src="img/diabetes-covid-artwork-1-1000.jpg" alt="Artwork 1: Layered Curtain" />
					<h3>Artist Statement I</h3>
					<p>All the submissions of the open call through this project are embedded into the breathable fabric layers. Moving from a layer to another, the emotional manifestation of the people with diabetes during Corona, displayed in images and texts, will move the general audience.</p>
				</div>
				<div>
					<video style="max-width: 100%;" src="img/diabetes-covid-artwork-2.mp4" type="video/mp4" muted loop autoplay playsinline />
					<h3>Artist Statement II</h3>
					<p>This collaboration presents my contemplation on what we are seeing or not seeing in diabetes and in people with diabetes and how we can empathise with them. During the Corona crisis, we all experienced the blues by social distance and sudden restrictions. On the Prussian blue canvas, the situation, mood, and emotions involved with the people with diabetes are illustrated all together. However, it is not obvious at a glimpse, and the actual scene appears only when the right light sheds on it. (...)</p>
				</div>
				<div>
					<video style="max-width: 100%;" src="img/diabetes-covid-artwork-3.mp4" type="video/mp4" muted loop autoplay playsinline />
					<h3>&nbsp;</h3>
					<p>(...) The UV light used here indicates ironical two sides of disinfecting benefit and damaging cells. The unique form, cornered canvases, contains cornered portraits, and the scripts surrounding the character are arranged based on the frequency of the words that researchers and people with diabetes of this project used. Overall, two parts of the artwork are at the same time connected and disconnected. The spectator will mediate the final communication of them.</p>
				</div>
				<!-- <Gallery gap="20" maxColumnWidth="300">
					<img src="img/diabetes-covid-artwork-2-a-1000.jpg" alt="Artwork 2: Blue canvases arranged in corner" />
					<img src="img/diabetes-covid-artwork-2-b-1000.jpg" alt="Artwork 2 illuminated." />
					<img src="img/diabetes-covid-artwork-3-a-1000.jpg" alt="Artwork 3" />
					<img src="img/diabetes-covid-artwork-3-b-1000.jpg" alt="Artwork 3 illuminated" />
				</Gallery> -->
			</div>
		</div>
	</Row>
	<Row>
		<div>
			<h3 id="onlineExhibition" class="w-300"><span class="caps w-800 primary">Online Exhibition —</span> Explore the collaborative artwork featuring 26 pieces.
			</h3>
			<p><a use:link={'/exhibition'}>Click here to see the online exhibition</a></p>
		</div>
		<div>
			<h3 class="w-300"><span class="caps w-800 primary">Theme of exhibition — </span>
				Visual artwork or written work that encourages recognition and reflection of the diverse experiences of people with diabetes during the pandemic. These can be positive, negative, or mixed. 
			</h3>
			<p><a on:click={() => cloud = !cloud}>{ cloud ? '▼ Hide' : '▶ Show'} themes</a></p>
		</div>

	</Row>
	<Row klass="{cloud ? 'show' : 'hide'}">
		<WordCloud />
	</Row>
	<!-- <Row klass="all-center row-big"> -->
		<!-- <div class="all-center"> -->
			<!-- <h1 class="caps w-800 full-width text-center"> -->
				<!-- <a class="bg-dots" use:link={'/submit'}>Submit Now</a> -->
			<!-- </h1> -->
			<!-- <p class="text-center">Submissions open until April 1, 2021</p> -->
		<!-- </div> -->
	<!-- </Row> -->
	<Row klass="all-center">
		<h1 class="caps w-800 full-width all-center" style="margin: var(--gap-l) 0">Team</h1>
	</Row>
	<Row klass="">
		<div class="min-300">
			<div class="color-img">
				<img alt="liz" src="../img/liz.jpg" />
				<h3 class="w-300 primary">Liz Morris</h3>
			</div>
			<p>I am a GP in Oxford and a clinical researcher in the Nuffield Department of Primary Care Health Sciences. My main area of research is type 2 diabetes, and learning how we can best support people with this condition in primary care.  Hearing from people living with all types of diabetes during the early Covid-19 pandemic inspired us to design this project, to hear more from people about their experiences.</p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="jamie" src="../img/jamie.jpg" />
				<h3 class="w-300 primary">Jamie Hartmann-Boyce</h3>
			</div>
			<p>I am a senior research fellow at the Nuffield Department of Primary Care Health Sciences, Oxford. I live with Type 1 Diabetes, and have done since I was a child. My research mainly focusses on bringing evidence together to inform healthcare decisions. During the pandemic this has included research on risks from COVID-19 in people with diabetes.</p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="gaynor" src="../img/gaynor.jpg" />
				<h3 class="w-300 primary">Gaynor Allen</h3>
			</div>
			<p>I am a member of the public living with Type 1 Diabetes. I was inspired to support this project because of its capacity to give people with diabetes a "voice" and a platform for sharing their experiences in a variety of forms; I hope that others with Diabetes will feel similarly inspired to engage.</p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="miranda" src="../img/miranda.jpg" />
				<h3 class="w-300 primary">Miranda Reilly</h3>
			</div>
			<p>I provide support as a Public Engagement Assistant on the project, and also work in Human Resources at the Nuffield Department of Primary Care Health Sciences. I am interested in representations of disability in art and literature, and enjoy painting as a hobby.</p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="clare" src="../img/clare.jpg" />
				<h3 class="w-300 primary">Clare Goyder</h3>
			</div>
			<p>I am a GP in Oxford and a Wellcome Trust Doctoral Fellow in the Nuffield Department of Primary Care Health Sciences. I bring clinical experience of managing patients with diabetes combined with personal as my husband has diabetes. </p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="partha" src="../img/partha.jpg" />
				<h3 class="w-300 primary">Partha Kar</h3>
			</div>
			<p>Consultant Diabetes in Portsmouth and National Speciality Advisor for Diabetes, NHS England. Partha has also been working in improving access to technology and leading on issues such as data analysis during COVID19 times, vaccine prioritisation and has an interest in arts especially in the #Diabetes community, for example <a style="outline: none; padding: 0; margin: 0; line-height: 1; display: inline; text-decoration: underline;" target="_blank" href="https://www.art1st.life/">art1st.life</a>.</p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="kamlesh" src="../img/kamlesh.jpg" />
				<h3 class="w-300 primary">Kamlesh Khunti</h3>
			</div>
			<p>Professor of Primary Care Diabetes and Vascular Medicine at the University of Leicester, UK, Co-Director of the Leicester Diabetes Centre, Director of the Centre for BME Health. Kamlesh’s work has influenced national and international guidelines on diabetes care and responses to COVID-19.</p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="yejeong" src="../img/yejeong.jpg" />
				<h3 class="w-300 primary"><a style="outline: none; padding: 0; margin: 0; line-height: 1; display: inline; text-decoration: underline;" href="https://www.yejeong.com/" target="_blank">Yejeong Mutter</a></h3>
			</div>
			<p>I am an artist, graduate from Royal College of Art, and a doctoral student in psychology at the University of Konstanz, working on bridging art and science. In this unpredicted Covid-19 occurrence, people with diabetes are facing physical and mental vulnerability in daily life. I believe emotional communication through art will have the power to connect all of us.</p>
			<p><a style="outline: none; padding: 0; margin: 0; line-height: 1; display: inline; text-decoration: underline;" href="https://www.yejeong.com/" target="_blank">Explore Yejeong’s work</a></p>
		</div>
		<div class="min-300">
			<div class="color-img">
				<img alt="johannes" src="../img/johannes.jpg" />
				<h3 class="w-300 primary">Johannes Mutter</h3>
			</div>
			<p>I’m a designer and engineer from Berlin and graduate of the Royal College of Art, London. I’m researching and developing systems for the transfer and remix of knowledge across disciplines, be it art, science, or technology.</p>
		</div>
		<div class="min-300" style="border: none;"><div class="color-img"></div></div>
		<div class="min-300" style="border: none;"><div class="color-img"></div></div>
	</Row>
	<Row klass="all-center row-big bg-dots-xs">
		<div class="all-center text-center">
			<h2 class="full-width all-center caps w-800"><a href="https://oxford.onlinesurveys.ac.uk/diabetescovidart-feedback2" target="_blank">Let us know what you think</a></h2>
			<p>We are keen to hear about your experiences and impressions to help us learn from this experience. <br>
				<a 
					href="https://oxford.onlinesurveys.ac.uk/diabetescovidart-feedback2" 
					target="_blank" 
					style="outline: none; padding: 0px; margin: 0px; line-height: 1; display: inline; text-decoration: underline;">Click here to complete a short survey</a>.
				</p>
		</div>
	</Row>
	<Row klass="all-center">
		<div class="text-center all-center">
			<p>
				<a class="bg-dots-xs" target="_blank" href="https://sites.google.com/view/perseedfund2020/living-with-diabetes-during-covid-19">PER Seed Fund </a>
				<a class="bg-dots-xs" target="_blank" href="https://www.phc.ox.ac.uk/research/covid-19/projects/diabetes-during-covid-19-capturing-experiences-of-a-pandemic">Project @ University Oxford</a>
			</p>
			<p>Learn more about this project and the “<b>P</b>ublic <b>E</b>ngagement with <b>R</b>esearch” (PER) Seed Fund.</p>
		</div>
		<div class="text-center all-center">
			<p><a class="bg-dots-xs" href="mailto:diabetescovid@phc.ox.ac.uk">diabetescovid@phc.ox.ac.uk</a></p>
			<p>For any questions or comments, please get in touch.</p>
		</div>
	</Row>
	<Row klass="text-center all-center">
		<p>Copyright © 2021</p>
	</Row>
	<Row klass="all-center footer">
		<img alt="Oxford" src="../img/Oxford-University-logo.png" />
	</Row>

</main>

<style type="text/scss">
	main {
		max-width: clamp(1600px,1600px,90vw);
		margin: 0 auto;
	}
</style>